/**
     * @desc 首页Trending Collections接口
用于查询Trending Collections的数据
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/collection/getTrendingCollectionList', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/collection/getTrendingCollectionList', params);
}
